import { Avatar, Tooltip, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { CHIP_COLORS } from '/@/components/chip-label';
import type { parseUserNode } from '/@/hooks/nodes';

export const ProfileIcon = ({
    userNode,
    type,
    size = 40,
    sx,
}: {
    userNode: ReturnType<typeof parseUserNode>;
    type: 'rv' | 'consultant' | 'advisor' | 'primary';
    size?: number;
    sx?: SxProps<Theme>;
}) => {
    const name = [
        userNode.name.toUpperCase()?.split(' ')[0]?.charAt(0),
        userNode.name.toUpperCase()?.split(' ')[1]?.charAt(0),
    ].join('');
    return (
        <Tooltip title={userNode.name} arrow>
            <Avatar
                sx={[
                    { background: CHIP_COLORS[type]?.background, width: size, height: size },
                    ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
                ]}
            >
                <Typography variant='caption' fontWeight='bold' color={CHIP_COLORS[type]?.color}>
                    {name}
                </Typography>
            </Avatar>
        </Tooltip>
    );
};
